<div class="info-content">
    <span [innerHTML]="message | safe: 'html'"></span>
</div>
